import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function QuestionCareRemindersPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    navigate('/onboarding/feedback-smart-watering')
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionCareReminders.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionCareReminders.yesPlease'),
          value: 'yes_please',
        },
        {
          text: t('pages.onboarding.questionCareReminders.maybeLater'),
          value: 'maybe_later',
        },
        {
          text: t('pages.onboarding.questionCareReminders.noThanks'),
          value: 'no_thanks',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
